import { Pin } from "lucide-react";
import { formatLandingReviewDate } from "@/lib/landingExample";
import { useI18n } from "@/i18n";
import styles from "./LandingVisual.module.css";

export function LandingAttention({ example: ex }) {
  const { t, lang } = useI18n();
  return (
    <section className={styles.attentionStory} aria-labelledby="landing-attention-title" data-testid="landing-attention-story">
      <div className={styles.attentionIntro}>
        <p className={styles.eyebrow}>{t("nav.attention")}</p>
        <h3 id="landing-attention-title">{t("landing.story.attentionTitle")}</h3>
        <p>{t("landing.story.attentionBody")}</p>
        <p className={styles.attentionRule}>{t("landing.story.attentionRule")}</p>
      </div>
      <div className={styles.attentionPreview} data-testid="landing-attention-preview">
        <div className={styles.attentionPreviewHeading}>
          <span>{t("example.badge")} / {t("nav.attention")}</span><span>{t("landing.story.attentionCount")}</span>
        </div>
        <article className={styles.attentionExampleCard} aria-labelledby="landing-attention-example-title">
          <div className={styles.attentionExampleMeta}>
            <span><Pin size={14} strokeWidth={1.5} aria-hidden="true" />{t("landing.story.pinnedByYou")}</span>
            <span>{t("landing.story.recorded")}</span>
          </div>
          <h4 id="landing-attention-example-title">{ex.title}</h4>
          <p>{ex.followThrough.nextAction}</p>
          <div className={styles.attentionExampleReview}>{t("commit.reviewDate")} · <time dateTime={ex.followThrough.reviewAt}>{formatLandingReviewDate(ex.followThrough.reviewAt, lang)}</time></div>
        </article>
        <p className={styles.attentionExampleNote}>{t("landing.story.attentionExampleNote")}</p>
      </div>
    </section>
  );
}
